import type {
  GetQuestionsKind,
  Question,
} from '@backmarket/nuxt-layer-buyback/app/scopes/offer/api/types'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

export function useFetchCategories(kind: GetQuestionsKind) {
  const $httpFetch = useHttpFetch()

  async function fetchCategories(): Promise<Question | null> {
    const response = await $httpFetch(
      '/buyback-funnel/api/v1/funnel/:kind/questions',
      {
        pathParams: { kind },
        query: {},
      },
    )

    const firstStepQuestions = response?.funnel?.[0]?.questions || []

    return firstStepQuestions[0] ?? null
  }

  return { fetchCategories }
}
